import { render, staticRenderFns } from "./ModalSwitchVersion.vue?vue&type=template&id=ab85f732&scoped=true"
import script from "./ModalSwitchVersion.vue?vue&type=script&lang=js"
export * from "./ModalSwitchVersion.vue?vue&type=script&lang=js"
import style0 from "./ModalSwitchVersion.vue?vue&type=style&index=0&id=ab85f732&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab85f732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab85f732')) {
      api.createRecord('ab85f732', component.options)
    } else {
      api.reload('ab85f732', component.options)
    }
    module.hot.accept("./ModalSwitchVersion.vue?vue&type=template&id=ab85f732&scoped=true", function () {
      api.rerender('ab85f732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/ModalSwitchVersion.vue"
export default component.exports